const Emoji = {
  '[TUIEmoji_Smile]': '[Smile]',
  '[TUIEmoji_Expect]': '[Expect]',
  '[TUIEmoji_Blink]': '[Blink]',
  '[TUIEmoji_Guffaw]': '[Guffaw]',
  '[TUIEmoji_KindSmile]': '[KindSmile]',
  '[TUIEmoji_Haha]': '[Haha]',
  '[TUIEmoji_Cheerful]': '[Cheerful]',
  '[TUIEmoji_Speechless]': '[Speechless]',
  '[TUIEmoji_Amazed]': '[Amazed]',
  '[TUIEmoji_Sorrow]': '[Sorrow]',
  '[TUIEmoji_Complacent]': '[Complacent]',
  '[TUIEmoji_Silly]': '[Silly]',
  '[TUIEmoji_Lustful]': '[Lustful]',
  '[TUIEmoji_Giggle]': '[Giggle]',
  '[TUIEmoji_Kiss]': '[Kiss]',
  '[TUIEmoji_Wail]': '[Wail]',
  '[TUIEmoji_TearsLaugh]': '[TearsLaugh]',
  '[TUIEmoji_Trapped]': '[Trapped]',
  '[TUIEmoji_Mask]': '[Mask]',
  '[TUIEmoji_Fear]': '[Fear]',
  '[TUIEmoji_BareTeeth]': '[BareTeeth]',
  '[TUIEmoji_FlareUp]': '[FlareUp]',
  '[TUIEmoji_Yawn]': '[Yawn]',
  '[TUIEmoji_Tact]': '[Tact]',
  '[TUIEmoji_Stareyes]': '[StarEyes]',
  '[TUIEmoji_ShutUp]': '[ShutUp]',
  '[TUIEmoji_Sigh]': '[Sigh]',
  '[TUIEmoji_Hehe]': '[Hehe]',
  '[TUIEmoji_Silent]': '[Silent]',
  '[TUIEmoji_Surprised]': '[Surprised]',
  '[TUIEmoji_Askance]': '[Askance]]',
  '[TUIEmoji_Ok]': '[OK]',
  '[TUIEmoji_Shit]': '[Shit]',
  '[TUIEmoji_Monster]': '[Monster]',
  '[TUIEmoji_Daemon]': '[Daemon]',
  '[TUIEmoji_Rage]': '[Rage]',
  '[TUIEmoji_Fool]': '[Fool]',
  '[TUIEmoji_Pig]': '[Pig]',
  '[TUIEmoji_Cow]': '[Cow]',
  '[TUIEmoji_Ai]': '[AI]',
  '[TUIEmoji_Skull]': '[Skull]',
  '[TUIEmoji_Bombs]': '[Bombs]',
  '[TUIEmoji_Coffee]': '[Coffee]',
  '[TUIEmoji_Cake]': '[Cake]',
  '[TUIEmoji_Beer]': '[Beer]',
  '[TUIEmoji_Flower]': '[Flower]',
  '[TUIEmoji_Watermelon]': '[Watermelon]',
  '[TUIEmoji_Rich]': '[Rich]',
  '[TUIEmoji_Heart]': '[Heart]',
  '[TUIEmoji_Moon]': '[Moon]',
  '[TUIEmoji_Sun]': '[Sun]',
  '[TUIEmoji_Star]': '[Star]',
  '[TUIEmoji_RedPacket]': '[RedPacket]',
  '[TUIEmoji_Celebrate]': '[Celebrate]',
  '[TUIEmoji_Bless]': '[Bless]',
  '[TUIEmoji_Fortune]': '[Fortune]',
  '[TUIEmoji_Convinced]': '[Convinced]',
  '[TUIEmoji_Prohibit]': '[Prohibit]',
  '[TUIEmoji_666]': '[666]',
  '[TUIEmoji_857]': '[857]',
  '[TUIEmoji_Knife]': '[Knife]',
  '[TUIEmoji_Like]': '[Like]',
};

export default Emoji;
